<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m48 15.84a38.09 38.09 0 1 0 38.08 38.09 38.08 38.08 0 0 0 -38.08-38.09zm0 72.16a34.06 34.06 0 0 1 -27.6-54l9.94 7.11c2.19 1.57 4.64-1.82 2.45-3.38l-9.73-7a34.07 34.07 0 0 1 55.63 38l-9.81-7.73c-2.25-1.77-5 1.77-2.7 3.54l10.27 8.1a34.06 34.06 0 0 1 -28.45 15.36z"
      fill="#4f2b1b"
    />
    <path
      d="m65.39 73.89-8-18.46c-.85-2-2-4-2.39-6.08-.53-3.05 0-6.59 0-9.7l-1.25 1.24c2.44 0 6.45-2.06 3.56-5-2-2-7.61-.84-9.94-.84s-8-1.11-9.94.84c-3.11 3.11 1.49 5 3.89 5l-1.25-1.24c0 3.21.77 7.39 0 10.49-.73 2.8-2.86 5.73-4.14 8.3l-6.16 12.31c-.95 1.9-2.94 4.6-1 6.56 1.45 1.44 4.54.89 6.34.89h13.67c3.49 0 17.24 2.42 16.78-3.68-.12-1.59-2.61-1.6-2.49 0 .16 2.11-5.26 1.19-6.5 1.19h-23.33c-2.38 0-2.77.12-2.13-2.09.94-3.23 3.25-6.52 4.75-9.52l5.14-10.28c2.26-4.53 1.58-9.15 1.58-14.17a1.27 1.27 0 0 0 -1.24-1.25c-.56 0-2.46 0-1.55-.83a7.91 7.91 0 0 1 1.46 0c1.88-.34 4.24 0 6.14 0s4.26-.35 6.14 0c.36.07 1.19-.2 1.46 0 .94.72-.69.83-1.22.83a1.26 1.26 0 0 0 -1.24 1.25c0 3.23-.45 6.82 0 10 .27 1.95 1.32 3.75 2.09 5.54l8.63 19.94c.63 1.48 2.75.22 2.14-1.24z"
      fill="#4f2b1b"
    />
    <g fill="#85c441">
      <path
        d="m61.53 73.71-7.38-15.58c-.58-1.23-1.09-3.29-2.14-4.21-1.69-1.48-5.08-2.18-7.18-3.08a.69.69 0 0 0 -.13 0 .63.63 0 0 0 -.93.3q-5.13 11.28-10.27 22.57a.78.78 0 0 0 .67 1.16h26.7a.78.78 0 0 0 .66-1.16z"
      />
      <path
        d="m44.37 21.73a1 1 0 0 1 -1.92 0 1 1 0 0 1 1.92 0c0 .74 1.2.74 1.16 0a2.12 2.12 0 1 0 -2.2 2.11 2.15 2.15 0 0 0 2.2-2.11c.04-.73-1.12-.73-1.16 0z"
      />
      <path
        d="m52.59 14.54a1 1 0 0 1 -1.93 0 1 1 0 0 1 1.93 0c0 .74 1.19.74 1.15 0a2.12 2.12 0 1 0 -4.23 0 2.12 2.12 0 0 0 4.23 0c.04-.74-1.11-.74-1.15 0z"
      />
      <path
        d="m45.4 31a1 1 0 0 1 -1.93 0 1 1 0 0 1 1.93 0c0 .74 1.2.74 1.16 0a2.12 2.12 0 0 0 -4.24 0 2.14 2.14 0 0 0 2 2.11 2.16 2.16 0 0 0 2.24-2.11c.04-.77-1.12-.77-1.16 0z"
      />
      <path
        d="m51.91 25.42a1 1 0 0 1 .14-1.36 1 1 0 1 1 1.15 1.54 1 1 0 0 1 -1.39-.29c-.46-.58-1.27.24-.81.81a2.11 2.11 0 1 0 .46-3.06 2.15 2.15 0 0 0 -.55 3c.41.56 1.41-.01 1-.64z"
      />
    </g>
  </svg>
</template>
